import { RocketAPI } from '@portal/rocket-api-client';
import { OptionsWithMeta } from 'utils/links';

const REPORTING_PARAMS = { duration: '24h' } as const;
const PAGE_PARAMS = { page: 1, per_page: 1 } as const;

type SiteTabOperations = (siteId: string | number) => OptionsWithMeta[];

export const siteTabOperations = {
  plugins: id => [RocketAPI.plugins.getListSitePluginsQueryOptions(Number(id))],

  themes: id => [RocketAPI.themes.getListSiteThemesQueryOptions(Number(id))],

  fileManager: id => [
    RocketAPI.files.getListSiteFileManagerFilesQueryOptions(Number(id), PAGE_PARAMS),
  ],

  backups: id => [
    RocketAPI.backups.getListSiteCloudBackupsQueryOptions(Number(id)),
    RocketAPI.backups.getListAutomatedSiteBackupsQueryOptions(Number(id)),
  ],

  logs: id => [
    RocketAPI.activity.getListSiteActivityEventsQueryOptions(Number(id)),
    RocketAPI.reporting.getListSiteAccessLogsQueryOptions(Number(id), REPORTING_PARAMS),
    RocketAPI.reporting.getReportOnSiteWafEventlistQueryOptions(Number(id), REPORTING_PARAMS),
  ],

  reporting: id => [
    RocketAPI.reporting.getReportOnSiteBandwidthTopUsageQueryOptions(Number(id), REPORTING_PARAMS),
    RocketAPI.reporting.getReportOnSiteCdnRequestsQueryOptions(Number(id), REPORTING_PARAMS),
    RocketAPI.reporting.getReportOnSiteWafEventsSourceQueryOptions(Number(id), REPORTING_PARAMS),
  ],

  security: id => [
    RocketAPI.passwordProtection.getFindSitePasswordProtectionQueryOptions(Number(id)),
    RocketAPI.sites.getLockSiteMutationOptions(),
  ],

  advanced: id => [
    RocketAPI.sites.getFindSiteSettingsQueryOptions(Number(id)),
    RocketAPI.sshKeys.getListSiteSshKeysQueryOptions(Number(id)),
  ],
} satisfies Record<string, SiteTabOperations>;
